export const variant =
  (variants, variantPropName = 'variant', defaultVariant = 'default') =>
  (props) => {
    const variantKey = props[variantPropName] || defaultVariant;
    return variants[variantKey];
  };
